<template>
    <div>
        <Navbar class="bg-white" />
        <PageTitle pageTitle="Single Cases" />
        <SingleCasesStudyTwo />
        <Newsletter />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import SingleCasesStudyTwo from '../SingleCasesStudy/SingleCasesStudyTwo'
import Newsletter from '../Common/Newsletter'
import Footer from '../Layout/Footer'

export default {
    name: 'SingleCasesStudyPage',
    components: {
        Navbar,
        PageTitle,
        SingleCasesStudyTwo,
        Newsletter,
        Footer,
    }
}
</script>